// utils.js
export const normalizeDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toISOString().split('T')[0];
  };
  
  export const formatDate = (date) => {
    if (!date) return '';
    try {
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      
      // Use proper date formatting to avoid locale issues
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: '2-digit' 
      };
      return d.toLocaleDateString('en-US', options);
    } catch (error) {
      console.warn('Date formatting error:', error);
      return date;
    }
  };
  
  export const formatNumber = (value, type = 'decimal') => {
    if (value == null || value === '') return '-';
    const number = parseFloat(value);
    if (isNaN(number)) return value;
    if (type === 'decimal4') return number.toFixed(4);
    if (type === 'comma') return new Intl.NumberFormat('en-US').format(number);
    return number;
  };
  
